import { coreApi } from "./coreApi";

export const storeInfoApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getStoreInfo: builder.query({
      query: () => ({
        url: "/profile",
        method: "GET",
      }),
      providesTags: ["User"],
    }),
    getAllStores: builder.query({
      query: (query) => ({
        url: `/stores?${query}`,
        method: "GET",
      }),
      providesTags: ["Stores"],
    }),
  }),
});

export const { useGetStoreInfoQuery, useGetAllStoresQuery } = storeInfoApi;
